import * as React from "react";
const SvgMassterIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#6366F1"
      d="M15.417 7.5c.696 0 1.256-.56 1.256-1.25v-.833c0-.69-.56-1.25-1.25-1.25H4.583c-.69 0-1.25.56-1.25 1.25v.833c0 .69.56 1.25 1.25 1.25zM2.5 13.75c0-1.15.933-2.083 2.083-2.083h10.84c1.15 0 2.083.932 2.083 2.083v.833c0 1.15-.933 2.084-2.083 2.084H4.583A2.083 2.083 0 0 1 2.5 14.583zm.833-5.833A2.08 2.08 0 0 1 2.5 6.25v-.833c0-1.15.933-2.084 2.083-2.084h10.84c1.15 0 2.083.933 2.083 2.084v.833a2.08 2.08 0 0 1-.833 1.667c.506.38.833.985.833 1.666v.834c0 1.15-.933 2.083-2.083 2.083a.417.417 0 1 1-.006-.833c.696 0 1.256-.56 1.256-1.25v-.834c0-.69-.56-1.25-1.25-1.25H4.583c-.69 0-1.25.56-1.25 1.25v.834c0 .69.56 1.25 1.25 1.25a.417.417 0 1 1 0 .833A2.083 2.083 0 0 1 2.5 10.417v-.834c0-.681.327-1.286.833-1.666m0 5.833v.833c0 .69.56 1.25 1.25 1.25h10.84c.69 0 1.25-.56 1.25-1.25v-.833c0-.69-.56-1.25-1.25-1.25H4.583c-.69 0-1.25.56-1.25 1.25m1.25-7.083a.417.417 0 0 1 0-.834H6.25a.417.417 0 0 1 0 .834zm0 4.166a.417.417 0 1 1 0-.833H6.25a.417.417 0 0 1 0 .833zm0 4.167a.417.417 0 1 1 0-.833H6.25a.417.417 0 1 1 0 .833z"
    />
  </svg>
);
export default SvgMassterIcon;